import _ from 'lodash';

import apiFactory from '@/api/default';
const API = apiFactory('products');

import productsHelper from '@/helpers/products.helper';

const state = {
  productSearchResults: [],
  currentProduct: {},
  selectedProducts: [],
};

const getters = {
  productSearchResults: (state) => state.productSearchResults,
  currentProduct: (state) => state.currentProduct,
  selectedProducts: (state) => state.selectedProducts,
};

const mutations = {
  setProductSearchResults: (state, productSearchResults) => {
    state.productSearchResults = productSearchResults;
  },
  removeFromProductSearchResults: (state, id) => {
    state.productSearchResults.data = state.productSearchResults.filter(
        (obj) => {
          return obj._id !== id;
        },
    );
    state.productSearchResults.total--;
  },
  setCurrentProduct: (state, currentProduct) => {
    state.currentProduct = currentProduct;
    // Workaround for database entries containing "null" for grip arrays -- we assume that grips are arrays!
    if (!state.currentProduct?.grips) {
      console.warn('Making an empty grips array...');
      state.currentProduct.grips = [];
    }
  },
  setSelectedProducts: (state, selectedProducts) => {
    state.selectedProducts = selectedProducts;
  },
  updateCurrentProductProperties: (state, properties) => {
    const changedProperties = {};
    for (const key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key)) {
        changedProperties[key] = properties[key];
      }
    }
    state.currentProduct = {...state.currentProduct, ...changedProperties};
  },
};

const actions = {
  async searchProducts({commit}, data) {
    const response = await API.search(data.query);
    if (data.opts?.setResultsInStore) {
      commit('setProductSearchResults', response.data);
    }
    return response.data;
  },
  async loadProduct({commit}, data) {
    const response = await API.load(data.id, data.query);
    if (data.setResultsInStore) {
      commit('setCurrentProduct', response.data);
    }
    return response.data;
  },
  async createProduct({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateProduct({commit}, payload) {
    const response = await API.update(payload.id, payload.props);
    // If the update is successful update currentProduct with the supplied props
    commit('updateCurrentProductProperties', payload.props);
    return response.data;
  },
  /**
   * Update currentProduct with populated props, de-populate them and updated the product in the DB
   *
   * @param {*} store - The Vuex store
   * @param {*} payload - object, supplied when calling this action
   * @property {string} [payload.id] - the _id of the product to be updated
   * @property {*} payload.props - properties to de-populate and save
   * @return {*} - server response
   */
  async updateProductProperty(store, payload) {
    const {id, props} = payload;
    const {getters, commit} = store;
    const populatedProperties = _.cloneDeep(props);
    // de-populate props
    for (const key of Object.keys(props)) {
      productsHelper.dePopulateProperty(props, key);
    }
    // Supplied id takes precedence
    let productId = undefined;
    if (id) {
      productId = id;
    } else if (getters.currentProduct._id) {
      productId = getters.currentProduct._id;
    } else {
      // No need to translate this since it is for developers eyes only!
      throw new Error('No id supplied and currentProduct is not loaded');
    }
    const response = await API.update(productId, props);
    // If the update is successful update currentProduct with populated props
    commit('updateCurrentProductProperties', populatedProperties);
    return response.data;
  },
  async deleteProduct({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromProductSearchResults', id);
    return response.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
